export default __webpack_public_path__ + "static/media/panelGameMain.1854c0a5.png";